import React from 'react';
import FCONN_ON from '../static/assets/FC_Smaller-Glow.png';
import FCONN_OFF from '../static/assets/FC_Smaller.png';
import ARROW from '../static/assets/arrow.png';
import EX from '../static/assets/x-mark.png';
import OPEN_ARROW from '../static/assets/open-arrow.png';
import '../static/css/body.css';
import DOWNLOAD from '../static/assets/download.png';
import IMPORT from '../static/assets/import.png';
import DOC from '../static/assets/document.png';
// import { isFlow } from '@babel/types';
// import { read } from 'fs';

// https://www.sohamkamani.com/blog/2017/08/21/enums-in-javascript/
const primTypes = {
    TEXT: 'Text',
    INT: 'Int64',
    DOUBLE: 'Double',
    BOOL: 'Boolean'
}
class AppContents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            primObjs: [] /*[
                {
                    name: 'Person',
                    pseudonyms: [
                        'person',
                        'Person'
                    ],
                    scalarfields: [
                        {
                            name: 'id',
                            type: primTypes.INT,
                            args: []
                        },
                        {
                            name: 'name',
                            type: primTypes.TEXT,
                            args: []
                        },
                        {
                            name: 'gender',
                            type: primTypes.INT,
                            args: [
                                {
                                    name: 'as',
                                    options: [
                                        {
                                            name: 'MALEFEMALE',
                                            type: primTypes.TEXT,
                                            prefix: 'CASE WHEN ',
                                            suffix: '==1 THEN MALE ELSE FEMALE END'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    objectfields: [
                        {
                            names: [
                                'pet'
                            ],
                            servername: 'Pet'
                        }
                    ],
                    databasetable: 'person',
                    uniqueids: [
                        'id'
                    ],
                    databaserelationships: [
                        ["person","id","pet","id","pet_ownership","owner_id","animal_id"],
                        ["person","id","breed","id","pet_ownership","owner_id","animal_id","pet","id","id","pet_type","pet_id","breed_id"],
                        ["person","id","species","id","pet_ownership","owner_id","animal_id","pet","id","id","pet_type","pet_id","breed_id","breed","id","species_id"],
                        ["person","id","genus","id","pet_ownership","owner_id","animal_id","pet","id","id","pet_type","pet_id","breed_id","breed","id","species_id","species","id","genus_id"],
                        ["person","id","family","id","pet_ownership","owner_id","animal_id","pet","id","id","pet_type","pet_id","breed_id","breed","id","species_id","species","id","genus_id","genus","id","family_id"]
                    ]
                },
                {
                    name: 'Pet',
                    pseudonyms: [
                        'pet',
                        'Pet'
                    ],
                    scalarfields: [
                        {
                            name: 'id',
                            type: primTypes.INT,
                            args: []
                        },
                        {
                            name: 'name',
                            type: primTypes.TEXT,
                            args: []
                        },
                        {
                            name: 'gender',
                            type: primTypes.INT,
                            args: [
                                {
                                    name: 'as',
                                    options: [
                                        {
                                            name: 'MALEFEMALE',
                                            type: primTypes.TEXT,
                                            prefix: 'CASE WHEN ',
                                            suffix: '==1 THEN MALE ELSE FEMALE END'
                                        }    
                                    ]
                                }
                            ]
                        }
                    ],
                    objectfields: [
                        {
                            names: [
                                'owner'
                            ],
                            servername: 'Person'
                        }
                    ],
                    databasetable: 'pet',
                    uniqueids: [
                        'id'
                    ],
                    databaserelationships: [
                        ["pet","id","person","id","pet_ownership","animal_id","owner_id"],
                        ["pet","id","breed","id","pet_type","pet_id","breed_id"],
                        ["pet","id","species","id","pet_type","pet_id","breed_id","breed","id","species_id"],
                        ["pet","id","genus","id","pet_type","pet_id","breed_id","breed","id","species_id","species","id","genus_id"],
                        ["pet","id","family","id","pet_type","pet_id","breed_id","breed","id","species_id","species","id","genus_id","genus","id","family_id"]
                    ]
                }
            ]*/,
            parentObjs: [] /*[
                {
                    name: 'Taxonomy',
                    pseudonyms: [
                        'taxonomy',
                        'Taxonomy'
                    ],
                    children: [
                        'Breed',
                        'Species',
                        'Family',
                        'Genus'
                    ]
                }
            ]*/,
            selObj: null /*{
                prim: true,
                idx: 0
            }*/, // of type { prim: bool, idx: int } */
            animateIdx: 0,
            dispPnts: false,
            isFullyConnected: false,
            pleaseWait: false,
            error: false,
            message: '',
            errorMessages: [], /*[
                'helloooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooo',
                'world'
            ],*/
            displayErrMsgs: false,
            links:[],
            confirm:false,
            confirmMsg:'',
            confirmFnc:null
        }
        this.isFileDirectoryReady = false;
        if (window.File&&window.FileReader&&window.FileList&&window.Blob) this.isFileDirectoryReady = true;
        // this.repositionButtons = this.repositionButtons.bind(this);
        this.reanimateButtons = this.reanimateButtons.bind(this);
        this.returnCircleRadius = this.returnCircleRadius.bind(this);
        this.overhaulSchematics = this.overhaulSchematics.bind(this);
        this.returnSchemaTags = this.returnSchemaTags.bind(this);
        this.returnSchemaDoc = this.returnSchemaDoc.bind(this);
    }
    // repositionButtons(state) {
    //     state.primObjs = state.primObjs.map((obj,idx,arr)=>{
    //         return {
    //             ...obj,
    //             left:Math.sin(360*(idx/arr.length)*(Math.PI/180))*displayRadius,
    //             top:-Math.cos(360*(idx/arr.length)*(Math.PI/180))*displayRadius
    //         };
    //     })
    //     this.setState(state);
    // }
    returnCircleRadius(state) {
        return Math.min(180,state.primObjs.length*(1/15)*100+80);
    }
    reanimateButtons(state) {
        if (this.interval!==null&&this.interval!==undefined) {
            clearInterval(this.interval);
        }
        this.setState({
            ...state,
            primObjs: state.primObjs.map(obj=>{
                return {
                    ...obj,
                    left:Math.sin(0)*this.returnCircleRadius(state),
                    top:Math.cos(0)*this.returnCircleRadius(state),
                };
            }),
            animateIdx:0,
            links:[]
        },()=>{
            this.interval = setInterval(()=>{
                let newState = this.state;
                let len = newState.primObjs.length;
                let piFactor = Math.PI/180;
                let posFactor = 360/len;
                newState.primObjs = newState.primObjs.map((obj,idx)=>{
                    if (idx*posFactor>=newState.animateIdx) {
                        obj.left = Math.sin(newState.animateIdx*piFactor)*this.returnCircleRadius(newState);
                        obj.top = -Math.cos(newState.animateIdx*piFactor)*this.returnCircleRadius(newState);
                    }
                    return obj;
                })
                newState.animateIdx += 1;
                if (newState.animateIdx===360) {
                    clearInterval(this.interval);
                    this.interval = null;
                    newState.animateIdx = 0;
                }
                this.setState(newState);
            },360/700);
        })
    }
    isFullyConnected(state) {
        if (state.primObjs.length<2) return false;
        let populationNames = state.primObjs.map(obj=>obj.name)
        return state.primObjs.every((obj,idx,arr)=>{
            return populationNames.every((populationObjName,idx2)=>{
                return idx===idx2||obj.objectfields.some(objField=>objField.servername===populationObjName)
            })
        })
    }
    overhaulSchematics(data) {
        let newState = this.state;
        newState.primObjs = [];
        if (Object.keys(data).indexOf('PrimaryObjects')!==-1) {
            newState.primObjs = data.PrimitiveObjects.map(obj=>{
                let nxtObj = {
                    name:'',
                    pseudonyms:[],
                    scalarfields:[],
                    objectfields:[],
                    databasetable:'',
                    uniqueids:[],
                    databaserelationships:[]
                }
                if (Object.keys(obj).indexOf('ServerName')!==-1&&typeof(obj.ServerName)==='string') {
                    nxtObj.name = obj.ServerName
                }
                if (Object.keys(obj).indexOf('Pseudonyms')!==-1&&obj.Pseudonyms.every(pnm=>typeof(pnm)==='string')) {
                    nxtObj.pseudonyms = obj.Pseudonyms
                }
                if (Object.keys(obj).indexOf('ScalarFields')!==-1) {
                    nxtObj.scalarfields = obj.ScalarFields.map(fld=>{
                        let nxtFld = {
                            name:'',
                            type:'',
                            args:[]
                        }
                        if (Object.keys(fld).indexOf('Name')!==-1&&typeof(fld.Name)==='string') {
                            nxtFld.name = fld.Name
                        }
                        if (Object.keys(fld).indexOf('Type')!==-1&&typeof(fld.Type)==='string') {
                            nxtFld.type = fld.Type
                        }
                        if (Object.keys(fld).indexOf('Arguments')!==-1) {
                            nxtFld.args = fld.Arguments.map(arg=>{
                                let nxtArg = {
                                    name: '',
                                    options: []
                                }
                                if (Object.keys(arg).indexOf('Name')!==-1&&typeof(arg.Name)==='string') {
                                    nxtArg.name = arg.Name
                                }
                                if (Object.keys(arg).indexOf('Options')!==-1) {
                                    nxtArg.options = arg.Options.map(opt=>{
                                        let nxtOpt = {
                                            name:'',
                                            type:'',
                                            prefix:'',
                                            suffix:''
                                        }
                                        if (Object.keys(opt).indexOf('Name')!==-1&&typeof(opt.Name)==='string') {
                                            nxtOpt.name = opt.Name
                                        }
                                        if (Object.keys(opt).indexOf('Type')!==-1&&typeof(opt.Type)==='string') {
                                            nxtOpt.type = opt.Type
                                        }
                                        if (Object.keys(opt).indexOf('Prefix')!==-1&&typeof(opt.Prefix)==='string') {
                                            nxtOpt.prefix = opt.Prefix
                                        }
                                        if (Object.keys(opt).indexOf('Suffix')!==-1&&typeof(opt.Suffix)==='string') {
                                            nxtOpt.suffix = opt.Suffix
                                        }
                                        return nxtOpt;
                                    })
                                }
                                return nxtArg;
                            })
                        }
                        return nxtFld;
                    })
                }
                if (Object.keys(obj).indexOf('ObjectFields')!==-1) {
                    nxtObj.objectfields = obj.ObjectFields.map(fobj=>{
                        let nxtFObj = {
                            names:[],
                            servername:''
                        }
                        if (Object.keys(fobj).indexOf('ServerName')!==-1&&typeof(fobj.ServerName)==='string') {
                            nxtFObj.servername = fobj.ServerName
                        }
                        if (Object.keys(fobj).indexOf('Names')!==-1&&fobj.Names.every(nm=>typeof(nm)==='string')) {
                            nxtFObj.names = fobj.Names
                        }
                        return nxtFObj;
                    })
                }
                if (Object.keys(obj).indexOf('DatabaseTable')!==-1&&typeof(obj.DatabaseTable)==='string') {
                    nxtObj.databasetable = obj.DatabaseTable;
                }
                if (Object.keys(obj).indexOf('UniqueIds')!==-1&&obj.UniqueIds.every(id=>typeof(id)==='string')) {
                    nxtObj.uniqueids = obj.UniqueIds
                }
                if (Object.keys(obj).indexOf('DatabaseRelationships')!==-1) {
                    nxtObj.databaserelationships = obj.DatabaseRelationships.filter(rel=>rel[0]===nxtObj.databasetable&&rel.every(tbl=>typeof(tbl)==='string'))
                }
                return nxtObj
            })
        }
        newState.parentObjs = [];
        if (Object.keys(data).indexOf('Interfaces')!==-1) {
            newState.parentObjs = data.ParentalObjects.map(obj=>{
                let nxtObj = {
                    pseudonyms: [],
                    name: '',
                    children: []
                }
                if (Object.keys(obj).indexOf('ServerName')!==-1&&typeof(obj.ServerName)==='string') {
                    nxtObj.name = obj.ServerName
                }
                if (Object.keys(obj).indexOf('Pseudonyms')!==-1&&obj.Pseudonyms.every(pnm=>typeof(pnm)==='string')) {
                    nxtObj.pseudonyms = obj.Pseudonyms
                }
                if (Object.keys(obj).indexOf('ServerChildren')!==-1&&obj.ServerChildren.every(chd=>typeof(chd)==='string')) {
                    nxtObj.children = obj.ServerChildren.filter(cld=>newState.primObjs.some(obj=>obj.name===cld))
                }
                return nxtObj
            })
        }
        newState.selObj = null
        newState.animateIdx = 0
        newState.dispPnts = false
        newState.isFullyConnected = this.isFullyConnected(newState)
        newState.pleaseWait = false

        // TODO: filter to valid values


        this.reanimateButtons(newState)
    }
    returnSchemaTags() {
        let result = {
            Interfaces: [],
            PrimaryObjects: []
        }

        this.state.parentObjs.forEach(obj=>{
            result.Interfaces.push({
                ServerName: obj.name,
                Pseudonyms: obj.pseudonyms,
                ServerChildren: obj.children
            });
        })

        this.state.primObjs.forEach(obj=>{
            result.PrimaryObjects.push({
                ServerName: obj.name,
                Pseudonyms: obj.pseudonyms,
                ScalarFields: obj.scalarfields.map(fld=>{
                    return {
                        Name: fld.name,
                        Type: fld.type,
                        Arguments: fld.args.map(arg=>{
                            return {
                                Name: arg.name,
                                Options: arg.options.map(opt=>{
                                    return {
                                        Name: opt.name,
                                        Type: opt.type,
                                        Prefix: opt.prefix,
                                        Suffix: opt.suffix
                                    };
                                })
                            };
                        })
                    };
                }),
                ObjectFields: obj.objectfields.map(fld=>{
                    return {
                        ServerName: fld.servername,
                        Names: fld.names
                    };
                }),
                DatabaseTable: obj.databasetable,
                UniqueIds: obj.uniqueids,
                DatabaseRelationships: obj.databaserelationships
            });
        })

        return result;
    }
    checkSchemaValidity(state) {
        state.errorMessages = [];

        // check no blank primitive obj names
        if (!state.primObjs.every(obj=>obj.name.trim().length>0))
            state.errorMessages.push('A primary object is missing a name.');
        // check no blank primitive obj pseudonyms
        if (!state.primObjs.every(obj=>obj.pseudonyms.length>0))
            state.errorMessages.push('A primary object is missing a pseudonym.');
        // check no blank primitive obj pseudonym
        if (!state.primObjs.every(obj=>
            obj.pseudonyms.every(pnm=>pnm.trim().length>0)))
            state.errorMessages.push('A primary object pseudonym is empty.');
        // check no blank scalar field
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>fld.name.trim().length>0)))
            state.errorMessages.push('A scalar field is missing a name.');
        // check no blank scalar field argument
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                fld.args.every(arg=>arg.name.trim().length>0))))
            state.errorMessages.push('A scalar field argument is missing a name.');
        // check no blank scalar field argument option
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                fld.args.every(arg=>arg.options.every(opt=>opt.name.trim().length>0)))))
            state.errorMessages.push('A scalar field argument option is missing a name.');
        // check no blank scalar field argument option prefix
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                fld.args.every(arg=>arg.options.every(opt=>opt.prefix.trim().length>0)))))
            state.errorMessages.push('A scalar field argument option is missing a prefix.');
        // check no blank scalar field argument option suffix
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                fld.args.every(arg=>arg.options.every(opt=>opt.suffix.trim().length>0)))))
            state.errorMessages.push('A scalar field argument option is missing a suffix.');
        // check no blank object field name
        if (!state.primObjs.every(obj=>
            obj.objectfields.every(fld=>fld.servername.trim().length>0)))
            state.errorMessages.push('An nested object field is missing a server object reference.');
        // check no blank object field names
        if (!state.primObjs.every(obj=>
            obj.objectfields.every(fld=>fld.names.length>0)))
            state.errorMessages.push('An nested object field is missing a name.');
        // check no blank object field name
        if (!state.primObjs.every(obj=>
            obj.objectfields.every(fld=>
                fld.names.every(nm=>nm.trim().length>0))))
            state.errorMessages.push('An nested object field name is empty.');
        // check no blank object field name
        if (!state.primObjs.every(obj=>
            obj.objectfields.every(fld=>
                fld.names.every(nm=>nm.trim().length>0))))
            state.errorMessages.push('An nested object field name is empty.');
        // check no blank primitive obj database table
        if (!state.primObjs.every(obj=>obj.databasetable.trim().length>0))
            state.errorMessages.push('A primary object is missing a database table.');
        // check no blank primitive obj unique ids
        if (!state.primObjs.every(obj=>obj.uniqueids.length>0))
            state.errorMessages.push('A primary object is missing a uniqueness id.');
        // check no empty primitive obj unique id
        if (!state.primObjs.every(obj=>
            obj.uniqueids.every(id=>id.trim().length>0)))
            state.errorMessages.push('A primary object uniqueness is empty.');
        // check no blank database relationship tables
        if (!state.primObjs.every(obj=>
            obj.databaserelationships.every(rel=>
                rel.every(table=>table.trim().length>0))))
            state.errorMessages.push('A database relationship table or field is left empty.');
        // check no blank parent obj
        if (!state.parentObjs.every(obj=>obj.name.trim().length>0))
            state.errorMessages.push('An interface is missing a name.');
        // check no blank parent obj psuedonyms
        if (!state.parentObjs.every(obj=>obj.pseudonyms.length>0))
            state.errorMessages.push('An interface is missing a pseudonym.');
        // check no blank parent obj psuedonym
        if (!state.parentObjs.every(obj=>
            obj.pseudonyms.every(pnm=>pnm.trim().length>0)))
            state.errorMessages.push('An interface is missing a pseudonym.');
        // check no blank parent obj children
        if (!state.parentObjs.every(obj=>obj.children.length>0))
            state.errorMessages.push('An interface is missing a child.');
        // check no blank parent obj child
        if (!state.parentObjs.every(obj=>
            obj.children.every(cld=>cld.trim().length>0)))
            state.errorMessages.push('An interface child is empty string.');

        // check no duplicate primitive objects
        if (!state.primObjs.every((obj,idx,arr)=>
                arr.slice(idx+1).every(elm=>obj.name!==elm.name)))
            state.errorMessages.push('Your schema is duplicate primitive objects.');
        // check no duplicate primitive object pseudonyms
        if (!state.primObjs.every(obj=>
                obj.pseudonyms.every((pnm,idx,arr)=>
                    arr.slice(idx+1).every(nnm=>pnm!==nnm))))
            state.errorMessages.push('Your schema is duplicate primitive object pseudonyms.');
        // check no duplicate primitive-primitive pseudonym
        if (!state.primObjs.every((obj,oidx,oarr)=>
            obj.pseudonyms.every(pnm=>
                oarr.slice(oidx+1).every(nobj=>
                    nobj.pseudonyms.every(npnm=>pnm!==npnm)))))
            state.errorMessages.push('Your schema is conflicting primitive object pseudonyms.');
        // check no duplicate primitive-parent pseudonym
        if (!state.primObjs.every(obj=>
            obj.pseudonyms.every(pnm=>
                state.parentObjs.every(pobj=>
                    pobj.pseudonyms.every(npnm=>pnm!==npnm)))))
            state.errorMessages.push('Your schema is conflicting primitive - parent object pseudonyms.');
        // check no duplicate primitive scalar name
        if (!state.primObjs.every(obj=>
                obj.scalarfields.every((fld,idx,arr)=>
                    arr.slice(idx+1).every(nfld=>fld.name!==nfld.name))))
            state.errorMessages.push('Your schema is duplicate primitive object scalar field.');
        // check no duplicate primitive scalar argument name
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                fld.args.every((arg,idx,arr)=>
                    arr.slice(idx+1).every(narg=>arg.name!==narg.name)))))
            state.errorMessages.push('Your schema is duplicate scalar field arguments.');
        // check no duplicate primitive scalar argument option name
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                fld.args.every(arg=>
                    arg.options.every((opt,idx,arr)=>
                        arr.slice(idx+1).every(nopt=>opt.name!==nopt.name))))))
            state.errorMessages.push('Your schema is duplicate scalar argument options.');
        // check no duplicate primitive object fields
        if (!state.primObjs.every(obj=>
            obj.objectfields.every((fld,idx,arr)=>
                arr.slice(idx+1).every(nfld=>fld.servername!==nfld.servername))))
            state.errorMessages.push('Your schema is duplicate nested object fields.');
        // check no duplicate primitive object field name
        if (!state.primObjs.every(obj=>
            obj.objectfields.every(fld=>
                fld.names.every((nm,idx,arr)=>
                    arr.slice(idx+1).every(nnm=>nm!==nnm)))))
            state.errorMessages.push('Your schema is duplicate nested object field names.');
        // check no duplicate primitive object database linkage
        if (!state.primObjs.every(obj=>
            obj.databaserelationships.every((rel,idx,arr)=>
                arr.slice(idx+1).every(nrel=>rel[2]!==nrel[2]))))
            state.errorMessages.push('Your schema is duplicate database relationships.');
        // check no duplicate parent object
        if (!state.parentObjs.every((obj,idx,arr)=>
            arr.slice(idx+1).every(nobj=>obj.name!==nobj.name)))
            state.errorMessages.push('Your schema is duplicate parent object.');
        // check no duplicate parent - primitive object
        if (!state.parentObjs.every(obj=>
            state.primObjs.every(probj=>obj.name!==probj.name)))
            state.errorMessages.push('Your schema is conflicting parent - primitive object names.');
        // check no duplicate parent pseudonym
        if (!state.parentObjs.every(obj=>
            obj.pseudonyms.every((pnm,idx,arr)=>
                arr.slice(idx+1).every(npnm=>pnm!==npnm))))
            state.errorMessages.push('Your schema is duplicate parent pseudonym.');
        // check no duplicate parent children
        if (!state.parentObjs.every(obj=>
            obj.children.every((chd,idx,arr)=>
                arr.slice(idx+1).every(nchd=>chd!==nchd))))
            state.errorMessages.push('Your schema is duplicate parent children.');

        // check validity of nested object serverobjects
        if (!state.primObjs.every((obj,_,arr)=>
            obj.objectfields.every(fld=>
                arr.some(nobj=>nobj.name===fld.servername)||state.parentObjs.some(pobj=>pobj.name===fld.servername))))
            state.errorMessages.push('A nested object is an invalid object.');
        // check existence of database relationships for every object field
        if (!state.primObjs.every((obj,_,arr)=>
            obj.objectfields.every(fld=>
                arr.some(nobj=>nobj.name===fld.servername&&
                    obj.databaserelationships.some(rel=>rel[2]===nobj.databasetable))||
                        state.parentObjs.some(pobj=>pobj.name===fld.servername&&
                            pobj.children.every(cld=>arr.some(cobj=>cobj.name===cld&&
                                obj.databaserelationships.some(rel=>rel[2]===cobj.databasetable)))))))
            state.errorMessages.push('A nested object field is missing a database relationship.');
        // check validity of parent children
        if (!state.parentObjs.every(obj=>
            obj.children.every(cld=>
                state.primObjs.some(probj=>probj.name===cld))))
            state.errorMessages.push('An interface child is an invalid object.');
        // check valid scalar field types
        let validTypes = Object.values(primTypes)
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                validTypes.some(typ=>typ===fld.type))))
            state.errorMessages.push('A scalar field is an invalid type.');
        // check valid scalar field argument option types
        if (!state.primObjs.every(obj=>
            obj.scalarfields.every(fld=>
                fld.args.every(arg=>
                    arg.options.every(opt=>
                        validTypes.some(typ=>typ===opt.type))))))
            state.errorMessages.push('A scalar field argument option is an invalid type.');

        return (state.errorMessages.length===0);
    }
    calculateLinksForIdx(state,idx) {
        let posFactor = 360/state.primObjs.length;
        let piFactor = Math.PI/180;
        let radius = this.returnCircleRadius(state)
        return state.primObjs[idx].objectfields.filter(fld=>state.primObjs.some(obj=>obj.name===fld.servername)).map((ffld)=>{
            let myTop = -Math.cos(idx*posFactor*piFactor)*radius+10;
            let myLeft = Math.sin(idx*posFactor*piFactor)*radius;
            let otherIdx = state.primObjs.reduce((acc,curr,idx)=>(curr.name===ffld.servername) ? idx : acc,0);
            let otherTop = -Math.cos(otherIdx*posFactor*piFactor)*radius+10;
            let otherLeft = Math.sin(otherIdx*posFactor*piFactor)*radius;
            let hypotenuse = Math.sqrt(Math.pow(Math.abs(myTop-otherTop),2)+Math.pow(Math.abs(myLeft-otherLeft),2));
            let angle = Math.atan((myTop-otherTop)/(-1*(otherLeft-myLeft)))*(180/Math.PI);
            if (myLeft>otherLeft) {
                myLeft -= (hypotenuse/2 + Math.cos(angle*piFactor)*hypotenuse/2)
                myTop -= Math.sin(angle*piFactor)*hypotenuse/2
            } else {
                myLeft -= (hypotenuse/2 - Math.cos(angle*piFactor)*hypotenuse/2)
                myTop += Math.sin(angle*piFactor)*hypotenuse/2
            }
            return {
                width:hypotenuse,
                top:myTop,
                left:myLeft,
                rot:angle,
            };
        })
    }
    returnSchemaDoc() {
        let result = '<!DOCTYPE html><html lang="en"><body style="background-color:silver;margin:30px;font-family:monospace;"><h1 style="text-align:center;">GraphQL DB Schema</h1>';

        result+='<h2>Interfaces</h2><ol>'

        this.state.parentObjs.forEach(parent=>{
            result+=`<li id="${parent.name}" style="border-style:solid;border-width:1px;border-color:black;padding:10px;margin:5px 0;background-color:rgba(255,255,255,0.5);"><div style="display:flex;flex-direction:column;">`
            result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Server Name:</b><a href="#${parent.name}" style="color:blue;">${parent.name}</a></div>`
            result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Reference Name(s):</b><span style="color:green;text-align:right;">${parent.pseudonyms.reduce((acc,curr)=>acc+', '+curr,'').substring(1)}</span></div>`
            result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Children Server Names:</b><span style="text-align:right;">${parent.children.reduce((acc,curr)=>acc+`, <a href="#${curr}" style="color:blue;">`+curr+'</a>','').substring(1)}</span></div>`
            result+=`</div></li>`
        });

        result += '</ol><h2>Primary Objects</h2><ol>'

        this.state.primObjs.forEach(prim=>{
            result+=`<li id="${prim.name}" style="border-style:solid;border-width:1px;border-color:black;padding:10px;margin:5px 0;background-color:rgba(255,255,255,0.5);"><div style="display:flex;flex-direction:column;">`
            result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Server Name:</b><a href="#${prim.name}" style="color:blue;">${prim.name}</a></div>`
            result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Reference Name(s):</b><span style="text-align:right;">${prim.pseudonyms.reduce((acc,curr)=>acc+', <span style="color:green;">'+curr+'</span>','').substring(1)}</span></div>`
            result+=`<div style="display:flex;flex-direction:column;"><b>Scalar Field(s):</b><ol>`
            prim.scalarfields.forEach(fld=>{
                result+=`<li><div style="display:flex;flex-direction:column;">`
                result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Name:</b><span style="color:green;">${fld.name}</span></div>`
                result+=`<div style="display:flex;flex-direction:column;"><b>Argument(s):</b><ol>`
                fld.args.forEach(arg=>{
                    result+=`<li><div style="display:flex;flex-direction:column;">`
                    result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Name:</b><span style="color:green;">${arg.name}</span></div>`
                    result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Option(s):</b><span style="text-align:right;">${arg.options.reduce((acc,curr)=>acc+', <span style="color:green;">'+curr.name+'</span>','').substring(1)}</span></div>`
                    result+=`</div></li>`
                });
                result+=`</ol></div></li>`
            });
            result+=`</ol></div><div style="display:flex;flex-direction:column;"><b>Nested Object Field(s):</b><ol>`
            prim.objectfields.forEach(fld=>{
                result+=`<li><div style="display:flex;flex-direction:column;">`
                result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Server Name:</b><a href="#${fld.servername}" style="color:blue;">${fld.servername}</a></div>`
                result+=`<div style="display:flex;flex-direction:row;justify-content:space-between;"><b>Reference Name(s):</b><span style="text-align:right;">${fld.names.reduce((acc,curr)=>acc+', <span style="color:green;">'+curr+'</span>','').substring(1)}</span></div>`
                result+=`</div></li>`
            });
            result+=`</ol></div></div></li>`
        });

        result += '</body></html>';
        return result;
    }
    componentDidMount() {
        this.setState({
            ...this.state,
            isFullyConnected: this.isFullyConnected(this.state)
        },()=>{this.reanimateButtons(this.state)})
    }
    componentDidUpdate(prevProps,prevState,snapshot) {
    }
    // body.index .hero::before {
    //     background: url("/img/graph-wash.png") repeat center center;
    //     content: '';
    //     height: 100%;
    //     position: absolute;
    //     top: 0;
    //     width: 100%;
    //   }
    //   body.index .hero header {
    //     background: linear-gradient(rgba(23, 30, 38, 0.8), rgba(23, 30, 38, 0));
    //     box-shadow: none;
    //     display: block;
    //   }
    render() {
        return (
            <React.Fragment>
                <div
                    id="Display"
                    style={{
                        background: "linear-gradient(rgba(23, 30, 38, 0.8), rgba(23, 30, 38, 0))",
                        height:'66.666%',
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'space-between',
                        alignItems:'flex-start',
                        overflow:'hidden'
                    }}
                    onClick={e=>{
                        if (!e.target.matches('.displayEntityBtn')&&!e.target.matches('.displayOptionBtn')&&!e.target.matches('#ImportFileSelect')) {
                            this.setState({
                                ...this.state,
                                selObj: null,
                                links: []
                            })
                        }
                    }}
                >
                    <img
                        alt={(this.state.isFullyConnected) ? 'fully connected indication (on)' : 'fully connected indication (off)'}
                        src={(this.state.isFullyConnected) ? FCONN_ON : FCONN_OFF}
                        style={{
                            height:'100px'
                        }}
                    />
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            justifyContent:'space-between',
                            width:'100%'
                        }}
                    >
                        <div
                            style={{
                                display:'flex',
                                flexDirection:'column' // TODO: on hover, zIndex is larger
                            }}
                        >
                            <input // https://developer.mozilla.org/en-US/docs/Web/API/FileReader add abort option, onerror event handler, maybe onprogress event handler
                                id='ImportFileSelect'
                                type='file'
                                style={{ display:'none' }}
                                accept='.json'
                                onChange={e=>{
                                    if (e.target.files.length>0) {
                                        let reactState = this;
                                        const reader = new FileReader();
                                        reader.onloadend = function() {
                                            try {
                                                let readObj = JSON.parse(reader.result)
                                                reactState.overhaulSchematics(readObj)
                                            } catch(err) {
                                                console.error(err)
                                                reactState.setState({
                                                    ...reactState,
                                                    error: true,
                                                    message: 'Sorry, we met an error while computing.'
                                                })
                                            }
                                        }
                                        reader.onloadstart = function(e) {
                                            reactState.setState({
                                                ...reactState,
                                                pleaseWait: true
                                            })
                                        }
                                        reader.readAsText(e.target.files[0])
                                        e.target.value = null
                                    } else { 
                                        let newState = this.state;
                                        newState.message = 'No file is selected.'
                                        newState.error = true
                                        this.setState(newState)
                                    }
                                }}
                            />
                            <button
                                className='displayOptionBtn'
                                disabled={!this.isFileDirectoryReady}
                                onClick={e=>{ document.getElementById('ImportFileSelect').click() }}
                            >
                                <img
                                    src={IMPORT}
                                    alt='import json file'
                                />
                                import schema
                            </button>
                            <a id='dlfile' style={{display:'none'}} href="."> </a>
                            <button
                                className='displayOptionBtn'
                                onClick={e=>{
                                    let newState = this.state;
                                    newState.pleaseWait = true;
                                    this.setState(newState,()=>{
                                        let newState = this.state;
                                        newState.message = '';
                                        if (this.state.primObjs.length===0&&this.state.parentObjs.length===0) {
                                            newState.message = "Sorry, you don't have data to export.";
                                        } else if (this.checkSchemaValidity(newState)) {
                                            var a = document.getElementById("dlfile");
        
                                            var json = JSON.stringify(this.returnSchemaTags(),undefined,4),
                                                blob = new Blob([json], {type: "application/json;charset=utf-8"}),
                                                url = window.URL.createObjectURL(blob);
        
                                            a.href = url;
                                            a.download = 'GqlDbISchema.json';
                                            a.click();
                                            window.URL.revokeObjectURL(url);
                                        } else {
                                            newState.message = 'Sorry, your schema is not ready!' // TODO: allow save progress option
                                        }
                                        if (newState.message.length>0)
                                            newState.error = true;
                                        newState.pleaseWait = false;
                                        this.setState(newState);
                                    })
                                    // https://code.sololearn.com/Wde1it1cKxXk/#js
                                    // https://www.jotform.com/blog/html5-filesystem-api-create-files-store-locally-using-javascript-webkit/
                                    // https://developers.google.com/web/updates/2011/08/Saving-generated-files-on-the-client-side
                                    // https://codepen.io/davidelrizzo/pen/cxsGb
                                    // https://gist.github.com/liabru/11263260
                                }}
                            >
                                <img
                                    src={DOWNLOAD}
                                    alt='download json file'
                                />
                                export schema
                            </button>
                        </div>
                        <div
                            style={{
                                display:'flex',
                                flexDirection:'column',
                                justifyContent:'flex-end'
                            }}
                        >
                            <button
                                className='displayOptionBtn'
                                onClick={e=>{
                                    let newState = this.state;
                                    newState.pleaseWait = true;
                                    this.setState(newState,()=>{
                                        let newState = this.state;
                                        newState.message = '';
                                        if (this.state.primObjs.length===0&&this.state.parentObjs.length===0) {
                                            newState.message = "Sorry, you don't have data to export.";
                                        } else if (this.checkSchemaValidity(newState)) {
                                            var a = document.getElementById("dlfile");
        
                                            var doc = this.returnSchemaDoc(),
                                                blob = new Blob([doc], {type: "text/html;charset=utf-8"}),
                                                url = window.URL.createObjectURL(blob);
        
                                            a.href = url;
                                            a.download = 'GqlDbISchemaReference.html';
                                            a.click();
                                            window.URL.revokeObjectURL(url);
                                        } else {
                                            newState.message = 'Sorry, your schema is not ready!' // TODO: allow save progress option
                                        }
                                        if (newState.message.length>0)
                                            newState.error = true;
                                        newState.pleaseWait = false;
                                        this.setState(newState);
                                    })
                                    // https://code.sololearn.com/Wde1it1cKxXk/#js
                                    // https://www.jotform.com/blog/html5-filesystem-api-create-files-store-locally-using-javascript-webkit/
                                    // https://developers.google.com/web/updates/2011/08/Saving-generated-files-on-the-client-side
                                    // https://codepen.io/davidelrizzo/pen/cxsGb
                                    // https://gist.github.com/liabru/11263260
                                }}
                            >
                                <img
                                    src={DOC}
                                    alt='download schema details'
                                />
                                download doc
                            </button>
                        </div>
                    </div>
                    
                    {/* <div
                        style={{
                            left:'50%',
                            width:'0',
                            borderWidth:'1px',
                            borderColor:'white',
                            borderStyle:'solid',
                            height:'100%',
                            position:'absolute'
                        }}
                    ></div> */}
                </div>
                {this.state.links.map((lnk,lidx)=>
                    <div
                        key={lidx}
                        className='displayLink'
                        style={{
                            width:`${lnk.width}px`,
                            height:'0px',
                            borderStyle:'solid none none none',
                            borderWidth:'3px',
                            borderColor:'silver',
                            left:'329px',
                            top:'220px',
                            marginLeft:`${lnk.left}px`,
                            marginTop:`${lnk.top}px`,
                            transform:`rotate(${lnk.rot}deg)`,
                            position:'fixed'
                        }}
                    ></div>
                )}
                {this.state.primObjs.map((prim,idx,arr)=>
                    <div
                        className='displayEntityContainer'
                        key={idx}
                        style={{
                            left:'329px',
                            top:'220px',
                            position:'fixed',
                            justifyContent:'center',
                            alignItems:'center',
                            width:'2px',
                            marginLeft:`${prim.left}px`,
                            marginTop:`${prim.top}px`                     
                        }}
                    >
                        <button
                            className='displayEntityBtn'
                            style={(this.state.selObj&&this.state.selObj.prim&&this.state.selObj.idx===idx) ? {
                                borderStyle:'solid',
                                borderWidth:'1px',
                                borderColor:'Gainsboro'
                            } : {
                                borderStyle:'none'
                            }}
                            onClick={e=>{
                                document.getElementById('ConfigPanel').scrollTop = 0;
                                this.setState({
                                    ...this.state,
                                    selObj: {
                                        prim: true,
                                        idx: idx
                                    },
                                    links: this.calculateLinksForIdx(this.state,idx)
                                });
                            }}
                        >{prim.name}</button>
                    </div>
                )}
                <div
                    id='parentDisplay'
                    style={{
                        borderRadius: '10px 0 0 10px',
                        backgroundColor:'#E10098',
                        width: (this.state.dispPnts) ? '300px' : '33px',
                        height:'300px',
                        flexDirection:'row',
                        justifyContent:'space-between',
                        alignItems:'center',
                        position:'fixed',
                        transition: 'left 2s, width 2s',
                        top:'56.5px',
                        left: (this.state.dispPnts) ? '330px' : '597px', // 'calc(630px - 33px)',
                        overflow:'hidden'
                    }}
                >
                    <div
                        style={{
                            height:'100%',
                            display:'flex',
                            flexDirection:'row',
                            justifyContent:'flex-start',
                            alignItems:'center',
                            width:'33px'
                        }}
                    >
                        <div
                            id='parentPanelOpenTab'
                            style={{
                                display:'flex',
                                flexDirection:'column',
                                justifyContent:'flex-start',
                                alignItems:'center',
                                height:'100%',
                                width:'33px',
                                overflow:'hidden',
                                cursor:'pointer'
                            }}
                            onClick={e=>{
                                let newState = this.state;
                                newState.dispPnts = !this.state.dispPnts;                                            
                                this.setState(newState)
                            }}
                        >
                            <div
                                id='parentArrowContainer'
                                style={{
                                    marginTop:'90px',
                                    transform:(this.state.dispPnts) ? 'rotate(0deg)' : 'rotate(180deg)',
                                    width:'15px',
                                    height:'15px',
                                    transition:'transform 0.7s'
                                }}
                            >
                                <img
                                    id='parentArrow'
                                    src={ARROW}
                                    alt='open or close parent object(s) window'
                                    style={{
                                        width:'100%',
                                        height:'100%'
                                    }}
                                />
                            </div>
                            <div style={{ transform:"rotate(270deg)" }} />
                            <h4
                                style={{
                                    transform:"rotate(270deg)",
                                    padding:'0',
                                    margin:'0',
                                    marginTop:'46px'
                                }}
                            >Interfaces</h4>
                        </div>
                        <div
                            style={{
                                height:'80%',
                                borderWidth:'0 1px 0 0',
                                borderStyle:'solid',
                                borderColor:'black'
                            }}
                        />
                    </div>
                    <div
                        style={{
                            overflowY:'scroll',
                            overflowX:'hidden',
                            display:'flex',
                            flexDirection:'column',
                            width:'calc(100% - 33px)',
                            height:'100%',
                        }}
                    >
                        {this.state.parentObjs.map((parent,idx)=>
                            <button
                                className='parentBtn'
                                key={idx}
                                onClick={e=>{
                                    this.setState({
                                        ...this.state,
                                        selObj: {
                                            prim: false,
                                            idx: idx
                                        }
                                    })
                                }}
                            >{parent.name}</button>
                        )}
                    </div>
                </div>
                <div
                    style={{
                        width:'280px',
                        left:'340px',
                        top:'40px',
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'flex-start',
                        position:'absolute'
                    }}
                >
                    <div
                        className='error'
                        style={{
                            borderWidth:'2px',
                            display:(this.state.errorMessages.length>0) ? 'flex' : 'none'
                        }}
                    >
                        <div
                            style={{
                                width:'calc(100% - 15px - 5px)',
                                overflowX:'scroll',
                                margin:'0',
                                textAlign:'left'
                            }}
                        >{this.state.errorMessages.length} error messages!</div>
                        <img
                            src={OPEN_ARROW}
                            alt='show error message(s)'
                            style={{
                                width:'15px',
                                height:'15px',
                                cursor:'pointer',
                                transform:(this.state.displayErrMsgs) ? 'rotate(180deg)' : 'rotate(0deg)'
                            }}
                            onClick={e=>{
                                let newState = this.state;
                                newState.displayErrMsgs = !newState.displayErrMsgs;
                                this.setState(newState)
                            }}
                        />
                    </div>
                    {this.state.displayErrMsgs&&this.state.errorMessages.map((msg,idx)=>
                        <div
                            key={idx}
                            className='error'
                        >
                            <div
                                style={{
                                    width:'calc(100% - 15px - 5px)',
                                    overflowX:'scroll',
                                    margin:'0',
                                    textAlign:'left'
                                }}
                            >{msg}</div>
                            <img
                                className='errorEx'
                                src={EX}
                                alt='close error message'
                                style={{
                                    width:'15px',
                                    height:'15px',
                                    cursor:'pointer'
                                }}
                                onClick={e=>{
                                    let newState = this.state;
                                    newState.errorMessages.splice(idx,1)
                                    this.setState(newState)
                                }}
                            />
                        </div>
                    )}
                </div>
                <div
                    id="ConfigPanel"
                    style={{
                        backgroundColor: "#E10098",
                        height:'33.333%',
                        overflowY:'scroll',
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'flex-start'
                    }}
                >
                    {(this.state.selObj===null) ? (
                        <div
                            style={{
                                display:'flex',
                                flexDirection:'row',
                                justifyContent:'space-around',
                                alignItems: 'center',
                                height:'100%'
                            }}
                        >
                            <button
                                className='configPanelOptionBtn'
                                onClick={e=>{
                                    let newState = this.state;
                                    newState.parentObjs.push({
                                        name: '',
                                        pseudonyms: [],
                                        children: []
                                    });
                                    newState.selObj = {
                                        prim: false,
                                        idx: newState.parentObjs.length - 1
                                    }
                                    newState.dispPnts = true;
                                    this.setState(newState)
                                }}
                            >Make Interface</button>
                            <button
                                className='configPanelOptionBtn'
                                onClick={e=>{
                                    let newState = this.state;
                                    newState.primObjs.push({
                                        name: '',
                                        pseudonyms: [],
                                        scalarfields: [],
                                        objectfields: [],
                                        databasetable: '',
                                        uniqueids: [],
                                        databaserelationships: []
                                    })
                                    newState.selObj = {
                                        prim: true,
                                        idx: newState.primObjs.length - 1
                                    }
                                    newState.isFullyConnected = false;
                                    this.reanimateButtons(newState)
                                }}
                            >Make Primary Object</button>
                        </div>
                    ) : ((this.state.selObj.prim===true) ? (
                        <React.Fragment>
                            <div
                                id='ServerNameSec'
                                className='configPanelSec'
                                style={{
                                    display:'flex',
                                    flexDirection:'row',
                                    justifyContent:'space-between',
                                    alignItems:'center'
                                }}
                            >
                                <h3>Server Name:</h3>
                                <input
                                    type='text'
                                    style={{
                                        textAlign:'right',
                                        width:'414.31px',
                                        padding:'0 5px',
                                        boxSizing:'border-box'
                                    }}
                                    onChange={e=>{
                                        let newState = this.state;newState.primObjs[newState.selObj.idx].name = e.target.value;
                                        this.setState(newState);
                                    }}
                                    onBlur={e=>{
                                        let newState = this.state;
                                        newState.isFullyConnected = this.isFullyConnected(newState)
                                        this.setState(newState);
                                    }}
                                    value={this.state.primObjs[this.state.selObj.idx].name}
                                    placeholder='Enter new server object name'
                                />
                            </div>
                            <div className='sectionDivider' />
                            <div
                                id='PseudonymSec'
                                className='configPanelSec'
                                style={{
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'flex-start'
                                }}
                            >
                                <h3>Pseudonyms:</h3>
                                <div
                                    id='PseudonymStickersSubSec'
                                    className='stickersBox'
                                >
                                    {this.state.primObjs[this.state.selObj.idx].pseudonyms.map((pseudonym,idx)=>{
                                        return <button
                                            key={idx}
                                            onClick={e=>{
                                                let newState = this.state;
                                                newState.confirm = true;
                                                newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].pseudonyms[idx]}" pseudonym for "${newState.primObjs[newState.selObj.idx].name}"?`
                                                newState.confirmFnc = () => {
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].pseudonyms.splice(idx,1);
                                                    this.setState(newState);
                                                }
                                                this.setState(newState);
                                            }}
                                            value={idx}
                                            className='sticker'
                                        >
                                            {pseudonym}
                                            <img
                                                className='stickerEx'
                                                alt={`delete ${pseudonym} pseudonym from ${this.state.primObjs[this.state.selObj.idx].name}`}
                                                src={EX}
                                            />    
                                        </button>
                                    })}
                                </div>
                                <div
                                    id='PseudonymInputSubSec'
                                    style={{width:'100%',overflowX:'hidden'}}
                                >
                                    <input
                                        id='PseudonymNameInput'
                                        type='text'
                                        style={{
                                            textAlign:'center',
                                            width:'100%',
                                            boxSizing:'border-box'
                                        }}
                                        onKeyUp={e=>{
                                            if (e.keyCode===13&&e.target.value.length>0&&!this.state.primObjs[this.state.selObj.idx].pseudonyms.some(pnm=>pnm===e.target.value)) {
                                                let newState = this.state;
                                                newState.primObjs[newState.selObj.idx].pseudonyms.push(e.target.value);
                                                this.setState(newState,()=>{document.getElementById('PseudonymNameInput').value='';});
                                            }
                                        }}
                                        placeholder='Enter new pseudonym name'
                                        autoComplete='off'
                                    />
                                    <button
                                        className='configBtn'
                                        onClick={e=>{
                                            let input = document.getElementById('PseudonymNameInput');
                                            if (input.value.length>0&&!this.state.primObjs[this.state.selObj.idx].pseudonyms.some(pnm=>pnm===input.value)) {
                                                let newState = this.state;
                                                newState.primObjs[newState.selObj.idx].pseudonyms.push(input.value);
                                                this.setState(newState,()=>{input.value='';});
                                            }
                                        }}
                                    >add pseudonym</button>
                                </div>
                            </div>
                            <div className='sectionDivider' />
                            <div
                                id='ScalarFieldSec'
                                className='configPanelSec'
                                style={{
                                    display:'flex',
                                    flexDirection:'column',
                                    justifyContent:'flex-start',
                                    alignItems:'flex-start'
                                }}
                            >
                                <h3>Scalar Fields</h3>
                                {this.state.primObjs[this.state.selObj.idx].scalarfields.map((field,sfIdx)=>
                                    <div
                                        key={sfIdx}
                                        style={{
                                            display:'flex',
                                            flexDirection:'column',
                                            justifyContent:'flex-start',
                                            alignItems:'center',
                                            width:'100%'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display:'flex',
                                                flexDirection:'row',
                                                width:'100%',
                                                alignItems:'center',
                                                justifyContent:'space-between'
                                            }}
                                        >
                                            <h4>Scalar name:</h4>
                                            <input
                                                type='text'
                                                style={{
                                                    width:'437.86px',
                                                    boxSizing:'border-box',
                                                    padding:'0 5px',
                                                    textAlign:'right'
                                                }}
                                                placeholder='Enter scalar name'
                                                value={field.name}
                                                onChange={e=>{
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].name = e.target.value;
                                                    this.setState(newState);
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                display:'flex',
                                                flexDirection:'row',
                                                width:'100%',
                                                alignItems:'center',
                                                justifyContent:'space-between'
                                            }}
                                        >
                                            <h4>Scalar type:</h4>
                                            <select
                                                onChange={e=>{
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].type = e.target.value;
                                                    this.setState(newState);
                                                }}
                                                value={this.state.primObjs[this.state.selObj.idx].scalarfields[sfIdx].type}
                                            >
                                                {Object.keys(primTypes).map(type=><option key={type} value={primTypes[type]}>{primTypes[type]}</option>)}
                                            </select>
                                        </div>
                                        <div
                                            style={{
                                                display:'flex',
                                                flexDirection:'column',
                                                width:'100%',
                                                justifyContent:'flex-start',
                                                alignItems:'flex-start'
                                            }}
                                        >
                                            <h4>Scalar arguments:</h4>
                                            {this.state.primObjs[this.state.selObj.idx].scalarfields[sfIdx].args.map((arg,aIdx)=>
                                                <React.Fragment key={aIdx}>
                                                    <div
                                                        style={{
                                                            display:'flex',
                                                            flexDirection:'row',
                                                            width:'100%',
                                                            alignItems:'center',
                                                            justifyContent:'space-between'
                                                        }}
                                                    >
                                                        <h5>Argument name:</h5>
                                                        <input
                                                            style={{
                                                                width:'427.83px',
                                                                padding:'0 5px',
                                                                boxSizing:'border-box',
                                                                textAlign:'right'
                                                            }}
                                                            type='text'
                                                            placeholder='Enter argument name'
                                                            value={arg.name}
                                                            onChange={e=>{
                                                                let newState = this.state;
                                                                newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].name = e.target.value;
                                                                this.setState(newState);
                                                            }}
                                                        />
                                                    </div>
                                                    <h5>Argument options:</h5>
                                                    {this.state.primObjs[this.state.selObj.idx].scalarfields[sfIdx].args[aIdx].options.map((opt,oIdx)=>
                                                        <React.Fragment key={oIdx}>
                                                            <div
                                                                style={{
                                                                    display:'flex',
                                                                    flexDirection:'row',
                                                                    width:'100%',
                                                                    alignItems:'center',
                                                                    justifyContent:'space-between'
                                                                }}
                                                            >
                                                                <h6>Option name:</h6>
                                                                <input
                                                                    type='text'
                                                                    style={{
                                                                        width:'464.22px',
                                                                        boxSizing:'border-box',
                                                                        padding:'0 5px',
                                                                        textAlign:'right'
                                                                    }}
                                                                    placeholder='Enter option name'
                                                                    value={opt.name}
                                                                    onChange={e=>{
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].options[oIdx].name = e.target.value;
                                                                        this.setState(newState);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display:'flex',
                                                                    flexDirection:'row',
                                                                    width:'100%',
                                                                    alignItems:'center',
                                                                    justifyContent:'space-between'
                                                                }}
                                                            >
                                                                <h6>Option type:</h6>
                                                                <select
                                                                    onChange={e=>{
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].options[oIdx].type = e.target.value;
                                                                        this.setState(newState);
                                                                    }}
                                                                    value={this.state.primObjs[this.state.selObj.idx].scalarfields[sfIdx].args[aIdx].options[oIdx].type}
                                                                >
                                                                    {Object.keys(primTypes).map(type=><option key={type} value={primTypes[type]}>{primTypes[type]}</option>)}
                                                                </select>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display:'flex',
                                                                    flexDirection:'row',
                                                                    width:'100%',
                                                                    alignItems:'center',
                                                                    justifyContent:'space-between'
                                                                }}
                                                            >
                                                                <h6>Option prefix:</h6>
                                                                <input
                                                                    type='text'
                                                                    style={{
                                                                        width:'462.34px',
                                                                        textAlign:'right',
                                                                        boxSizing:'border-box',
                                                                        padding:'0 5px'
                                                                    }}
                                                                    placeholder='Enter option prefix'
                                                                    value={opt.prefix}
                                                                    onChange={e=>{
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].options[oIdx].prefix = e.target.value;
                                                                        this.setState(newState);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display:'flex',
                                                                    flexDirection:'row',
                                                                    width:'100%',
                                                                    alignItems:'center',
                                                                    justifyContent:'space-between'
                                                                }}
                                                            >
                                                                <h6>Option suffix:</h6>
                                                                <input
                                                                    type='text'
                                                                    style={{
                                                                        width:'463.7px',
                                                                        textAlign:'right',
                                                                        boxSizing:'border-box',
                                                                        padding:'0 5px'
                                                                    }}
                                                                    placeholder='Enter option suffix'
                                                                    value={opt.suffix}
                                                                    onChange={e=>{
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].options[oIdx].suffix = e.target.value;
                                                                        this.setState(newState);
                                                                    }}
                                                                />
                                                            </div>
                                                            <button
                                                                className='configBtn'
                                                                onClick={e=>{
                                                                    let newState = this.state;
                                                                    newState.confirm = true;
                                                                    newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].options[oIdx].name}" option for "${newState.primObjs[newState.selObj.idx].name}" scalar field "${newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].name}" argument "${newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].name}"?`
                                                                    newState.confirmFnc = () => {
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].options.splice(oIdx,1);
                                                                        this.setState(newState);
                                                                    }
                                                                    this.setState(newState);
                                                                }}
                                                            >delete option</button>
                                                        </React.Fragment>
                                                    )}
                                                    <button
                                                        className='configBtn'
                                                        onClick={e=>{
                                                            let newState = this.state;
                                                            newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].options.push({
                                                                name:'',
                                                                type: primTypes.TEXT,
                                                                prefix: '',
                                                                suffix: ''
                                                            })
                                                            this.setState(newState);
                                                        }}
                                                    >add new option</button>
                                                    <button
                                                        className='configBtn'
                                                        onClick={e=>{
                                                            let newState = this.state;
                                                            newState.confirm = true;
                                                            newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args[aIdx].name}" argument for "${newState.primObjs[newState.selObj.idx].name}" scalar field "${newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].name}"?`
                                                            newState.confirmFnc = () => {
                                                                let newState = this.state;
                                                                newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args.splice(aIdx,1);
                                                                this.setState(newState);
                                                            }
                                                            this.setState(newState);
                                                        }}
                                                    >delete argument</button>
                                                </React.Fragment>
                                            )}
                                            <button
                                                className='configBtn'
                                                onClick={e=>{
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].args.push({
                                                        name:'',
                                                        options:[]
                                                    })
                                                    this.setState(newState);
                                                }}
                                            >add new argument</button>
                                        </div>
                                        <button
                                            className='configBtn'
                                            onClick={e=>{
                                                let newState = this.state;
                                                newState.confirm = true;
                                                newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].scalarfields[sfIdx].name}" scalar field for "${newState.primObjs[newState.selObj.idx].name}"?`
                                                newState.confirmFnc = () => {
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].scalarfields.splice(sfIdx,1)
                                                    this.setState(newState)
                                                }
                                                this.setState(newState);
                                            }}
                                        >delete scalar field</button>
                                    </div>
                                )}
                                <button
                                    className='configBtn'
                                    onClick={e=>{
                                        let newState = this.state;
                                        newState.primObjs[newState.selObj.idx].scalarfields.push({
                                            name:'',
                                            type: primTypes.TEXT,
                                            args: []
                                        })
                                        this.setState(newState);
                                    }}
                                >add new scalar field</button>
                            </div>
                            <div className='sectionDivider' />
                            <div
                                id='NestedObjectFieldSec'
                                className='configPanelSec'
                                style={{
                                    display:'flex',
                                    flexDirection:'column',
                                    justifyContent:'flex-start',
                                    alignItems:'flex-start'
                                }}
                            >
                                <h3>Nested Object Fields</h3>
                                {this.state.primObjs[this.state.selObj.idx].objectfields.map((field,noIdx)=>
                                    <div
                                        key={noIdx}
                                        style={{
                                            display:'flex',
                                            flexDirection:'column',
                                            justifyContent:'flex-start',
                                            alignItems:'center',
                                            width:'100%'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display:'flex',
                                                flexDirection:'row',
                                                width:'100%',
                                                alignItems:'center',
                                                justifyContent:'space-between'
                                            }}
                                        >
                                            <h4>Server object name:</h4>
                                            <select
                                                style={{
                                                    textAlign:'center'
                                                }}
                                                value={field.servername}
                                                onChange={e=>{
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].objectfields[noIdx].servername = e.target.value;
                                                    newState.isFullyConnected = this.isFullyConnected(newState);
                                                    newState.links = this.calculateLinksForIdx(this.state,this.state.selObj.idx);
                                                    this.setState(newState);
                                                }}
                                            >
                                                {this.state.primObjs.map(obj=><option key={obj.name} value={obj.name}>{obj.name}</option>)}
                                                {this.state.parentObjs.map(obj=><option key={obj.name} value={obj.name}>{obj.name}</option>)}
                                            </select>
                                        </div>
                                        <div
                                            id={`NestedObjectSec${this.state.selObj.idx}-${noIdx}`}
                                            style={{
                                                display:'flex',
                                                flexDirection:'column',
                                                alignItems:'flex-start',
                                                width:'100%'
                                            }}
                                        >
                                            <h4>Nested object names:</h4>
                                            <div
                                                id={`NestedObjectStickersSubSec${this.state.selObj.idx}-${noIdx}`}
                                                className='stickersBox'
                                            >
                                                {this.state.primObjs[this.state.selObj.idx].objectfields[noIdx].names.map((name,idx)=>{
                                                        return <button
                                                            className='sticker'
                                                            key={idx}
                                                            onClick={e=>{
                                                                let newState = this.state;
                                                                newState.confirm = true;
                                                                newState.confirmMsg = `Are you sure that you want to delete "${name}" name for "${newState.primObjs[newState.selObj.idx].name}" nested object "${newState.primObjs[newState.selObj.idx].objectfields[noIdx].servername}"?`
                                                                newState.confirmFnc = () => {
                                                                    let newState = this.state;
                                                                    newState.primObjs[newState.selObj.idx].objectfields[noIdx].names.splice(idx,1);
                                                                    this.setState(newState);
                                                                }
                                                                this.setState(newState);
                                                            }}
                                                            value={idx}
                                                        >
                                                            {name}
                                                            <img
                                                                className='stickerEx'
                                                                alt={`delete ${name} name from ${this.state.primObjs[this.state.selObj.idx].name} nested object ${this.state.primObjs[this.state.selObj.idx].objectfields[noIdx].servername}`}
                                                                src={EX}
                                                            />    
                                                        </button>
                                                })}
                                            </div>
                                            <div
                                                id={`NestedObjectInputSubSec${this.state.selObj.idx}-${noIdx}`}
                                                style={{width:'100%',overflowX:'hidden'}}
                                            >
                                                <input
                                                    id={`NestedObjectNameInput${this.state.selObj.idx}-${noIdx}`}
                                                    type='text'
                                                    style={{
                                                        textAlign:'center',
                                                        width:'100%'
                                                    }}
                                                    onKeyUp={e=>{
                                                        if (e.keyCode===13&&e.target.value.length>0&&!this.state.primObjs[this.state.selObj.idx].objectfields[noIdx].names.some(nm=>nm===e.target.value)) {
                                                            let newState = this.state;
                                                            newState.primObjs[newState.selObj.idx].objectfields[noIdx].names.push(e.target.value);
                                                            this.setState(newState,()=>{document.getElementById(`NestedObjectNameInput${this.state.selObj.idx}-${noIdx}`).value='';});
                                                        }
                                                    }}
                                                    placeholder='Enter new nested object name'
                                                    autoComplete='off'
                                                />
                                                <button
                                                    className='configBtn'
                                                    onClick={e=>{
                                                        let input = document.getElementById(`NestedObjectNameInput${this.state.selObj.idx}-${noIdx}`);
                                                        if (input.value.length>0&&!this.state.primObjs[this.state.selObj.idx].objectfields[noIdx].names.some(nm=>nm===input.value)) {
                                                            let newState = this.state;
                                                            newState.primObjs[newState.selObj.idx].objectfields[noIdx].names.push(input.value);
                                                            this.setState(newState,()=>{input.value='';});
                                                        }
                                                    }}
                                                >add nested object name</button>
                                            </div>
                                        </div>
                                        <button
                                            className='configBtn'
                                            onClick={e=>{
                                                let newState = this.state;
                                                newState.confirm = true;
                                                newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].objectfields[noIdx].servername}" nested object field for "${newState.primObjs[newState.selObj.idx].name}"?`
                                                newState.confirmFnc = () => {
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].objectfields.splice(noIdx,1)
                                                    newState.isFullyConnected = this.isFullyConnected(newState);
                                                    this.setState(newState)
                                                }
                                                this.setState(newState);
                                            }}
                                        >delete object field</button>
                                    </div>
                                )}
                                <button
                                    className='configBtn'
                                    onClick={e=>{
                                        let newState = this.state;
                                        newState.primObjs[newState.selObj.idx].objectfields.push({
                                            servername: '',
                                            names: []
                                        });
                                        this.setState(newState);
                                    }}
                                >add new nested object field</button>
                            </div>
                            <div className='sectionDivider' />
                            <div
                                id='DatabaseSec'
                                className='configPanelSec'
                                style={{
                                    display:'flex',
                                    flexDirection:'column',
                                    justifyContent:'flex-start',
                                    alignItems:'flex-start',
                                    width:'100%'
                                }}
                            >
                                <h3>Database Specifications</h3>
                                <div
                                    id='DBTableNameSec'
                                    style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        justifyContent:'space-between',
                                        alignItems:'center',
                                        width:'100%'
                                    }}
                                >
                                    <h3>Database table name:</h3>
                                    <input
                                        type='text'
                                        style={{
                                            width:'343.52px',
                                            textAlign:'right',
                                            boxSizing:'border-box',
                                            padding:'0 5px'
                                        }}
                                        onChange={e=>{
                                            let newState = this.state;
                                            newState.primObjs[newState.selObj.idx].databasetable = e.target.value;
                                            this.setState(newState);
                                        }}
                                        onBlur={e=>{
                                            let newState = this.state;
                                            newState.primObjs[newState.selObj.idx].databaserelationships = newState.primObjs[newState.selObj.idx].databaserelationships.map(rel=>{
                                                let newRel = rel;
                                                newRel[0] = newState.primObjs[newState.selObj.idx].databasetable;
                                                return newRel;
                                            })
                                            this.setState(newState);
                                        }}
                                        value={this.state.primObjs[this.state.selObj.idx].databasetable}
                                        placeholder='Enter database table name'
                                    />
                                </div>
                                <div
                                    id='UniqIdSec'
                                    style={{
                                        display:'flex',
                                        flexDirection:'column',
                                        alignItems:'flex-start',
                                        width:'100%'
                                    }}
                                >
                                    <h3>Unique ID columns:</h3>
                                    <div
                                        id='UniqIdsStickersSubSec'
                                        className='stickersBox'
                                    >
                                        {this.state.primObjs[this.state.selObj.idx].uniqueids.map((id,idx)=>{
                                            return <button
                                                key={idx}
                                                onClick={e=>{
                                                    let newState = this.state;
                                                    newState.confirm = true;
                                                    newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].uniqueids[idx]}" unique id column for "${newState.primObjs[newState.selObj.idx].name}"?`
                                                    newState.confirmFnc = () => {
                                                        let newState = this.state;
                                                        newState.primObjs[newState.selObj.idx].uniqueids.splice(idx,1);
                                                        this.setState(newState);
                                                    }
                                                    this.setState(newState);
                                                }}
                                                value={idx}
                                                className='sticker'
                                            >
                                                {id}
                                                <img
                                                    className='stickerEx'
                                                    alt={`delete ${this.state.primObjs[this.state.selObj.idx].uniqueids[idx]} unique id from ${this.state.primObjs[this.state.selObj.idx].name}`}
                                                    src={EX}
                                                />   
                                            </button>
                                        })}
                                    </div>
                                    <div
                                        id='UniqIdsInputSubSec'
                                        style={{width:'100%',overflowX:'hidden'}}
                                    >
                                        <input
                                            id='UniqIdsNameInput'
                                            type='text'
                                            style={{
                                                textAlign:'center',
                                                width:'100%'
                                            }}
                                            onKeyUp={e=>{
                                                if (e.keyCode===13&&e.target.value.length>0&&!this.state.primObjs[this.state.selObj.idx].uniqueids.some(id=>id===e.target.value)) {
                                                    let newState = this.state;
                                                    newState.primObjs[newState.selObj.idx].uniqueids.push(e.target.value);
                                                    this.setState(newState,()=>{document.getElementById('UniqIdsNameInput').value='';});
                                                }
                                            }}
                                            placeholder='Enter new pseudonym name'
                                            autoComplete='off'
                                        />
                                        <button
                                            className='configBtn'
                                            onClick={e=>{
                                                let input = document.getElementById('UniqIdsNameInput');
                                                let newState = this.state;
                                                if (input.value.length>0&&!newState.primObjs[newState.selObj.idx].uniqueids.some(id=>id===input.value)) {
                                                    newState.primObjs[newState.selObj.idx].uniqueids.push(input.value);
                                                    this.setState(newState,()=>{input.value='';});
                                                }
                                            }}
                                        >add unique id column name</button>
                                    </div>
                                </div>
                                <div
                                    id='DBRelationshipsSec'
                                    style={{
                                        display:'flex',
                                        flexDirection:'column',
                                        alignItems:'flex-start',
                                        width:'100%'
                                    }}
                                >
                                    <h3>Database relationships:</h3>
                                    {this.state.primObjs[this.state.selObj.idx].databaserelationships.map((rel,relIdx)=>
                                        <div
                                            key={relIdx}
                                            style={{
                                                width:'100%',
                                                display:'flex',
                                                flexDirection:'column',
                                                justifyContent:'flex-start',
                                                alignItems:'flex-start',
                                                overflowX:'scroll'
                                            }}
                                        >
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td style={{fontWeight:'bold',fontSize:'12px'}}>table name</td>
                                                        <td>{this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx][0]}</td>
                                                        {this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx].slice(4).map((entry,idx)=>
                                                            (idx%3===0) && (
                                                                <td key={idx}><input
                                                                    value={entry}
                                                                    onChange={e=>{
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][idx+4] = e.target.value;
                                                                        this.setState(newState);
                                                                    }}
                                                                /></td>
                                                            )
                                                        )}
                                                        <td><input
                                                            type='text'
                                                            value={this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx][2]}
                                                            onChange={e=>{
                                                                let newState = this.state;
                                                                newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][2] = e.target.value;
                                                                this.setState(newState);
                                                            }}
                                                        /></td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{fontWeight:'bold',fontSize:'12px'}}>entering column</td>
                                                        <td>-</td>
                                                        {this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx].slice(4).map((entry,idx)=>
                                                            (idx%3===1) && (
                                                                <td key={idx}><input
                                                                    value={entry}
                                                                    onChange={e=>{
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][idx+4] = e.target.value;
                                                                        this.setState(newState);
                                                                    }}
                                                                /></td>
                                                            )
                                                        )}
                                                        <td><input
                                                            value={this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx][3]}
                                                            onChange={e=>{
                                                                let newState = this.state;
                                                                newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][3] = e.target.value;
                                                                this.setState(newState);
                                                            }}
                                                        /></td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{fontWeight:'bold',fontSize:'12px'}}>leaving column</td>
                                                        <td><input
                                                            value={this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx][1]}
                                                            onChange={e=>{
                                                                let newState = this.state;
                                                                newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][1] = e.target.value;
                                                                this.setState(newState);
                                                            }}
                                                        /></td>
                                                        {this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx].slice(4).map((entry,idx)=>
                                                            (idx%3===2) && (
                                                                <td key={idx}><input
                                                                    value={entry}
                                                                    onChange={e=>{
                                                                        let newState = this.state;
                                                                        newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][idx+4] = e.target.value;
                                                                        this.setState(newState);
                                                                    }}
                                                                /></td>
                                                            )
                                                        )}
                                                        <td>-</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{fontWeight:'bold',fontSize:'12px'}}>actions</td>
                                                        <td>
                                                            <button
                                                                className='relationshipTableBtn'
                                                                onClick={e=>{
                                                                    let newState = this.state;
                                                                    newState.primObjs[newState.selObj.idx].databaserelationships[relIdx].splice(4,0,'','','');
                                                                    this.setState(newState);
                                                                }}
                                                            >add table after</button>
                                                        </td>
                                                        {this.state.primObjs[this.state.selObj.idx].databaserelationships[relIdx].slice(4).map((entry,idx)=>
                                                            (idx%3===0) && (
                                                                <td key={idx}>
                                                                    <div
                                                                        style={{
                                                                            display:'flex',
                                                                            flexDirection:'row',
                                                                            justifyContent:'space-around',
                                                                            alignItems:'center',
                                                                            width:'100%',
                                                                            height:'100%',
                                                                            padding:'0'
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className='relationshipTableBtn'
                                                                            onClick={e=>{
                                                                                let newState = this.state;
                                                                                newState.primObjs[newState.selObj.idx].databaserelationships[relIdx].splice(4+idx,0,'','','');
                                                                                this.setState(newState);
                                                                            }}
                                                                        >add table before</button>
                                                                        <button
                                                                            className='relationshipTableBtn'
                                                                            onClick={e=>{
                                                                                let newState = this.state;
                                                                                newState.confirm = true;
                                                                                newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][4+idx]}" table from "${newState.primObjs[newState.selObj.idx].name}" database table relationships?`
                                                                                newState.confirmFnc = () => {
                                                                                    let newState = this.state;
                                                                                    newState.primObjs[newState.selObj.idx].databaserelationships[relIdx].splice(4+idx,3);
                                                                                    this.setState(newState);
                                                                                }
                                                                                this.setState(newState);
                                                                            }}
                                                                        >delete table</button>
                                                                        <button
                                                                            className='relationshipTableBtn'
                                                                            onClick={e=>{
                                                                                let newState = this.state;
                                                                                newState.primObjs[newState.selObj.idx].databaserelationships[relIdx].splice(4+idx+3,0,'','','');
                                                                                this.setState(newState);
                                                                            }}
                                                                        >add table after</button>
                                                                    </div>
                                                                </td>
                                                            )
                                                        )}
                                                        <td>
                                                            <button
                                                                className='relationshipTableBtn'
                                                                onClick={e=>{
                                                                    let newState = this.state;
                                                                    newState.primObjs[newState.selObj.idx].databaserelationships[relIdx].push('','','');
                                                                    this.setState(newState);
                                                                }}
                                                            >add table before</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <button
                                                className='configBtn'
                                                onClick={e=>{
                                                    let newState = this.state;
                                                    newState.confirm = true;
                                                    newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][0]}" to "${newState.primObjs[newState.selObj.idx].databaserelationships[relIdx][2]}" database relationship from "${newState.primObjs[newState.selObj.idx].name}"?`
                                                    newState.confirmFnc = () => {
                                                        let newState = this.state;
                                                        newState.primObjs[newState.selObj.idx].databaserelationships.splice(relIdx,1)
                                                        this.setState(newState)
                                                    }
                                                    this.setState(newState);
                                                }}
                                            >delete this relationship</button>
                                        </div>
                                    )}
                                    <button
                                        className='configBtn'
                                        onClick={e=>{
                                            let newState = this.state;
                                            newState.primObjs[newState.selObj.idx].databaserelationships.push([
                                                newState.primObjs[newState.selObj.idx].databasetable,'','',''
                                            ]);
                                            this.setState(newState);
                                        }}
                                    >add new relationship</button>
                                </div>
                            </div>
                            <button
                                className='configBtn'
                                onClick={e=>{
                                    let newState = this.state;
                                    newState.confirm = true;
                                    newState.confirmMsg = `Are you sure that you want to delete "${newState.primObjs[newState.selObj.idx].name}" primitive?`
                                    newState.confirmFnc = () => {
                                        let newState = this.state;
                                        newState.primObjs.splice(newState.selObj.idx,1)
                                        newState.selObj = null;
                                        newState.links = [];
                                        newState.isFullyConnected = this.isFullyConnected(newState);
                                        this.reanimateButtons(newState)
                                    }
                                    this.setState(newState);
                                }}
                            >delete object</button>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div
                                id='ServerNameSec'
                                style={{
                                    display:'flex',
                                    flexDirection:'row',
                                    justifyContent:'space-between',
                                    alignItems:'center'
                                }}
                            >
                                <h3>Server Name:</h3>
                                <input
                                    type='text'
                                    style={{
                                        textAlign:'right',
                                        width:'414.31px',
                                        padding:'0 5px',
                                        boxSizing:'border-box'
                                    }}
                                    onChange={e=>{
                                        let newState = this.state;
                                        newState.parentObjs[newState.selObj.idx].name = e.target.value;
                                        this.setState(newState);
                                    }}
                                    value={this.state.parentObjs[this.state.selObj.idx].name}
                                    placeholder='Enter new server object name'
                                />
                            </div>
                            <div
                                id='PseudonymSec'
                                style={{
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'flex-start'
                                }}
                            >
                                <h3>Pseudonyms:</h3>
                                <div
                                    id='PseudonymStickersSubSec'
                                    className='stickersBox'
                                >
                                    {this.state.parentObjs[this.state.selObj.idx].pseudonyms.map((pseudonym,idx)=>{
                                            return <button
                                                key={idx}
                                                onClick={e=>{
                                                    let newState = this.state;
                                                    newState.confirm = true;
                                                    newState.confirmMsg = `Are you sure that you want to delete "${newState.parentObjs[newState.selObj.idx].pseudonyms[idx]}" pseudonym from "${newState.parentObjs[newState.selObj.idx].name}" parent object?`
                                                    newState.confirmFnc = () => {
                                                        let newState = this.state;
                                                        newState.parentObjs[newState.selObj.idx].pseudonyms.splice(idx,1);
                                                        this.setState(newState);
                                                    }
                                                    this.setState(newState);
                                                }}
                                                value={idx}
                                                className='sticker'
                                            >
                                                {pseudonym}
                                                <img
                                                    className='stickerEx'
                                                    alt={`delete ${this.state.parentObjs[this.state.selObj.idx].pseudonyms[idx]} pseudonym from ${this.state.parentObjs[this.state.selObj.idx].name} parent object`}
                                                    src={EX}
                                                />
                                            </button>
                                    })}
                                </div>
                                <div
                                    id='PseudonymInputSubSec'
                                    style={{width:'100%',overflowX:'hidden'}}
                                >
                                    <input
                                        id='PseudonymNameInput'
                                        type='text'
                                        style={{
                                            textAlign:'center',
                                            width:'100%'
                                        }}
                                        onKeyUp={e=>{
                                            if (e.keyCode===13&&e.target.value.length>0&&!this.state.parentObjs[this.state.selObj.idx].pseudonyms.some(pnm=>pnm===e.target.value)) {
                                                let newState = this.state;
                                                newState.parentObjs[newState.selObj.idx].pseudonyms.push(e.target.value);
                                                this.setState(newState,()=>{document.getElementById('PseudonymNameInput').value='';});
                                            }
                                        }}
                                        placeholder='Enter new pseudonym name'
                                        autoComplete='off'
                                    />
                                    <button
                                        className='configBtn'
                                        onClick={e=>{
                                            let input = document.getElementById('PseudonymNameInput');
                                            if (input.value.length>0&&!this.state.parentObjs[this.state.selObj.idx].pseudonyms.some(pnm=>pnm===input.value)) {
                                                let newState = this.state;
                                                newState.parentObjs[newState.selObj.idx].pseudonyms.push(input.value);
                                                this.setState(newState,()=>{input.value='';});
                                            }
                                        }}
                                    >add pseudonym</button>
                                </div>
                                <div
                                    id='ChildrenSec'
                                    style={{
                                        display:'flex',
                                        flexDirection:'column',
                                        alignItems:'flex-start',
                                        width:'100%'
                                    }}
                                >
                                    <h3>Interpretations:</h3>
                                    <div
                                        id='PrimObjStickersSubSec'
                                        className='stickersBox'
                                    >
                                        {this.state.parentObjs[this.state.selObj.idx].children.map((child,idx)=>{
                                            return <button
                                                key={idx}
                                                onClick={e=>{
                                                    let newState = this.state;
                                                    newState.confirm = true;
                                                    newState.confirmMsg = `Are you sure that you want to delete "${newState.parentObjs[newState.selObj.idx].children[idx]}" child from "${newState.parentObjs[newState.selObj.idx].name}" parent object?`
                                                    newState.confirmFnc = () => {
                                                        let newState = this.state;
                                                        newState.parentObjs[newState.selObj.idx].children.splice(idx,1);
                                                        this.setState(newState);
                                                    }
                                                    this.setState(newState);
                                                }}
                                                value={idx}
                                                className='sticker'
                                            >
                                                {child}
                                                <img
                                                    className='stickerEx'
                                                    alt={`delete ${this.state.parentObjs[this.state.selObj.idx].children[idx]} child from ${this.state.parentObjs[this.state.selObj.idx].name} parent object`}
                                                    src={EX}
                                                />   
                                            </button>
                                        })}
                                    </div>
                                    <div
                                        id='PrimObjInputSubSec'
                                        style={{width:'100%',overflowX:'hidden'}}
                                    >
                                        <select
                                            id='PrimObjNameInput'
                                            style={{
                                                textAlign:'center',
                                                width:'100%'
                                            }}
                                        >
                                            {this.state.primObjs.map(obj=><option key={obj.name} value={obj.name}>{obj.name}</option>)}
                                        </select>
                                        <button
                                            className='configBtn'
                                            onClick={e=>{
                                                let input = document.getElementById('PrimObjNameInput');
                                                if (input.value.length>0&&!this.state.parentObjs[this.state.selObj.idx].children.some(cld=>cld===input.value)) {
                                                    let newState = this.state;
                                                    newState.parentObjs[newState.selObj.idx].children.push(input.value);
                                                    this.setState(newState);
                                                }
                                            }}
                                        >add child</button>
                                    </div>
                                </div>
                            </div>
                            <button
                                className='configBtn'
                                onClick={e=>{
                                    let newState = this.state;
                                    newState.confirm = true;
                                    newState.confirmMsg = `Are you sure that you want to delete "${newState.parentObjs[newState.selObj.idx].name}" parent object?`
                                    newState.confirmFnc = () => {
                                        let newState = this.state;
                                        newState.parentObjs.splice(newState.selObj.idx,1)
                                        newState.selObj = null;
                                        this.setState(newState)
                                    }
                                    this.setState(newState);
                                }}
                            >delete object</button>
                        </React.Fragment>    
                    ))}
                </div>
                {this.state.pleaseWait&&(<div
                    style={{
                        backgroundColor:'rgba(50,50,50,0.7)',
                        position:'fixed',
                        top:'30px',
                        left:'30px',
                        width:'600px',
                        height:'600px',
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                >
                    <div
                        style={{
                            width:'300px',
                            height:'100px',
                            backgroundColor:'black',
                            borderRadius:'20px',
                            color:'white'
                        }}
                    >
                        <h1>please wait</h1>
                    </div>
                </div>)}
                {this.state.confirm&&(<div
                    style={{
                        position:'fixed',
                        top:'30px',
                        left:'30px',
                        width:'600px',
                        height:'600px',
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                >
                    <div
                        style={{
                            width:'auto',
                            height:'auto',
                            backgroundColor:'lightgray',
                            color:'black',
                            padding:'10px 30px',
                            boxShadow:'0px 0px 50px black'
                        }}
                    >
                        <h1 style={{margin:'0'}}>Confirmation</h1>
                        <p>{this.state.confirmMsg}</p>
                        <div
                            style={{
                                display:'flex',
                                flexDirection:'row',
                                justifyContent:'space-around',
                                alignItems:'center'
                            }}
                        >
                            <button
                                id='confirmYes'
                                className='confirmBtn'
                                onClick={e=>{
                                    this.state.confirmFnc();
                                    this.setState({
                                        ...this.state,
                                        confirm:false,
                                        confirmMsg:'',
                                        confirmFnc:null
                                    })
                                }}
                            >Yes</button>
                            <button
                                id='confirmNo'
                                className='confirmBtn'
                                onClick={e=>{
                                    this.setState({
                                        ...this.state,
                                        confirm:false,
                                        confirmMsg:'',
                                        confirmFnc:null
                                    })
                                }}
                            >No</button>
                        </div>
                    </div>
                </div>)}
                {this.state.error&&(<div
                    style={{
                        backgroundColor:'rgba(50,50,50,0.7)',
                        position:'fixed',
                        top:'30px',
                        left:'30px',
                        width:'600px',
                        height:'600px',
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                >
                    <div
                        style={{
                            width:'300px',
                            height:'100px',
                            backgroundColor:'black',
                            borderRadius:'20px',
                            color:'white'
                        }}
                    >
                        <p>{this.state.message}</p>
                        <button
                            style={{
                                cursor:'pointer'
                            }}
                            onClick={e=>{
                                this.setState({
                                    ...this.state,
                                    error:false
                                })
                            }}
                        >Close</button>
                    </div>
                </div>)}
            </React.Fragment>
        );
    }
}

export default AppContents;
